import loanRejection from "@/api/credit-operation/loan-rejection";
import { baseState, baseMutations } from "@/store/mixins";

export const state = {
    ...baseState,
    customers: [],
    rejected_bys: [],
    currencies: []
};

export const getters = {};

export const mutations = {
    ...baseMutations,
    SET_CUSTOMERS(state, data) {
        state.customers = data;
    },
    SET_REJECTED_BYS(state, data) {
        state.rejected_bys = data;
    },
    SET_CURRENCIES(state, data) {
        state.currencies = data;
    },
    CLEAR_RESOURCES(state) {
        state.customers = [];
        state.rejected_bys = [];
        state.currencies = [];
    }
};

export const actions = {
    fetch(context, attributes = {}) {
        let params = Object.assign(
            {
                page: context.state.pagination.page,
                perPage: context.state.pagination.perPage,
                filter: {
                    search: context.state.search
                }
            },
            attributes
        );
        return loanRejection.get({ params }).then(response => {
            context.commit("RECEIVE_RESOURCES", response);
            return Promise.resolve(response);
        });
    },
    store(context, data) {
        return loanRejection.store(data);
    },
    update(context, { id, data }) {
        return loanRejection.update(id, data);
    },
    destroy(context, { id, data }) {
        return loanRejection.destroy(id, data);
    },
    async getCustomers(context) {
        let response = await loanRejection.customer();
        context.commit("SET_CUSTOMERS", response.data);
    },
    async getRejectedBys(context) {
        let response = await loanRejection.rejectedBy();
        context.commit("SET_REJECTED_BYS", response.data);
    },
    async getCurrencies(context) {
        let response = await loanRejection.currency();
        context.commit("SET_CURRENCIES", response.data);
    }
};